var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "url(#pattern0_332_2511)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 16,
    width: 18,
    height: 18,
    fill: "url(#pattern1_332_2511)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_332_2511",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_332_2511",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_332_2511",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_332_2511",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_332_2511",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB4UlEQVR4nO3dT04CMRiG8VnpIdT7eAFiv3gF9S4sWu7AVvvhCRRX41nEvaYgiSH+SWaa9AWeX9INCxK+Z1p2064DAAAAAAAAAByRqV+epkW4S27LlMN7cvtg2e8z2MxoGT3cltlVjTG7n5zFbK8EsIEPYejLDKvEKHWJYRVOg9BX2SlfxxTHk4+fwSzbzeggMYcXgliVBzLm8Dx+h2RbEcTqnBDZVuODHOtxle2h/BFP/fo8uvngz3cWQXxYkDLY7fDi49XF0M8J4nV2CEHEVnTz9fGzedoXQz9nh7j24j/E20cgiLcfPEG8/bAJ4u0HTBBvP1SpIKO/8MgkgmghiBiCiCGIGIKIIYgYgoghiBiCiCGIGIKIIYgYgoghiBiCiCGIGIKIIYgYgoghiBiCiCGIGIKIIYgYgoghiBiCiCGIGIKIIYgYgoghiBiCiCGIGIKIIYgYgoghiBiCiCGIGIKIIYgYgoghiBiCiCGIGIKIIYgYghx8kJ2X8X9/4zP+tvvK8ejhrat9XcX2Dc6jv/jAxR/ecF3luopyh1LrF0emA1lVLnRZXwbmoW/9Y9Ler9DP55OTroZyLwZRTONSsK1St2y5cg5y6479HyHbKubwVGZWbWcAAAAAAAAAALr98AmgFD81gx3rawAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_332_2511",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADQklEQVR4nO2dPY4TQRCFO4Ir8HOujZDcT4TAEGK0npbvQ4REN9zAQMDCVdBuQgTqkZHQsAKv3VP9ylVPqsRaeb56b2rGQak3hP9oeD/cj3kzxDJ+Qk43KOkndeV0M7GW9OLizfZeOCet3l0+jiV9625yObbGr7WHcA6aJkN1GOn3xFydxaTEnF52N7O0qVg2z4N2oaTPvY1Euyn5GLQr5vH6bCYkj9dBu3qbiMYVtKu3gfBAPBBq9b6j4RNyXCCd7hd1nGYahRJOM41CCaeZRqGE00yjUMJpplEo4TTTKJRwmmkUSjjNNAolnGYahRLOk2WmUS3yQMjEGshgdQuGMZCV5S0YtkAG61swbIFE61swbIHA+hYMWyDR+hYMWyAgMLJlLWbAIu7fot4GeiAz9TbQA5mpt4EeCPkjVJyTzQCQ8YhzshkAMh5xTjYDQMYjzslmAMh4xDnZDAAZjzgnmwEg4xHnZDMAZDzinGwGgIxHnJPNAJDxiHOyGQAyHnFONgNAxiPOyWYAyHjEOdkMABmPOCebASDjEedkMwBkPOKcbAaAjEeck80AkPGIc7IZADIecU42A0DGI87JZgDIeMQ52QwAGY84J5sBIOMR52QzAGQ84pxsBoCMR5yTzQCQ8YhzshkAMh5xTjYDQMYjzslmAMh4xDnZDAAZjzjnoV+8dIWlG20sD6R4ID4h/5BPSPEJaTAh449Y0qunb7ePaiGP6/oZ/B1y+ugdVXlc/3W9KZTkL/UegTz5cPlwfr2Ytw88kE4TUh9T8+vVU3LgE8LzyIo5vfZAegVSX+B5XPtLXeFhL2Gvu/59Ly3GuT+WzgOhCSRvBg+EKJB6pF49I7B3KGHpRhtrUc7pp2hOVx7I4Vr8xqkHNtYzAlHGXY8XfZBqtJG0cJppFEo4zTQKJZxmGoUSTjONQgmnmUahhNNMo1DCKdYolFTQLhCY6IH8od4GeiAz9TbQA5mJZQumVQXtAskWjAeyF8sWjAeyF8sWjAdCtgXjgZBtwXggZFswjSbye9CuSLIF02gid0G7IskWTJsJSc+Cdg0kWzCnVizjl5P+BSuTVgRbMKeGcdtPbNW66LwFc+cQJsZxVx9Th0zGL8sxHEOLn4tHAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileCross);
export default __webpack_public_path__ + "static/media/mobileCross.c558cb830e61d2f0f6a0c83b5009589c.svg";
export { ForwardRef as ReactComponent };